module.exports = __webpack_public_path__ + "images/icons_v2/alert-outlined-d39c1961.svg";